import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { Button, ButtonProps } from '~/components/ui/Button';
import { useFormContext } from '~/components/Form/FormContext.tsx';
import { hasFieldError } from '~/components/Form/utils.ts';

type SubmitButtonProps = ButtonProps & {
  allowUnchanged?: boolean;
  ref?: HTMLButtonElement;
};

export default function SubmitButton(props: SubmitButtonProps): JSXElement {
  const merged = mergeProps(
    {
      allowUnchanged: false
    },
    props
  );
  // excluding properties that are defined in this component
  const [componentProps] = splitProps(merged, ['allowUnchanged']);
  const [elementProps, buttonProps] = splitProps(merged, ['type', 'disabled']);
  const formAccessors = useFormContext();

  return (
    <Button
      ref={merged.ref}
      {...buttonProps}
      type={'submit'}
      loading={formAccessors.isSubmitting()}
      disabled={
        elementProps.disabled ||
        hasFieldError(formAccessors.errors()) ||
        (!componentProps.allowUnchanged && !formAccessors.isChanged())
      }
    >
      {merged.children}
    </Button>
  );
}
